import { initializeApp } from "firebase/app";
export class FirebaseConfig {
    private static firebaseConfig = {
        apiKey: "AIzaSyBfotJyhB1xpdu7BKccGhx7jNfkB0DNEVg",
        authDomain: "send-it-93ac6.firebaseapp.com",
        projectId: "send-it-93ac6",
        storageBucket: "hailr",
        messagingSenderId: "353870586232",
        appId: "1:353870586232:web:c38a6098863ff10f05a88d",
        measurementId: "G-WL121K7WW1"
      };

    public static app = initializeApp(FirebaseConfig.firebaseConfig);
}